import { t } from 'i18next';
import { OhpenValidationError } from '@pmp/api';
import { DeleteErrorException } from '@ohpen/enso-ui';

export function createDeleteErrorException(error?: OhpenValidationError): DeleteErrorException {
  if (!error) {
    return new DeleteErrorException(t('global.errors.unexpected'));
  }
  const { title, status, errors } = error;
  let description: string | string[] = t('global.errors.unexpected');
  const invalidParams = error['invalid-params'];
  let message;

  if (title) message = title;
  if (status === 400 && invalidParams) {
    description = invalidParams.map(param => `${param.name}: ${param.reason}`);
  }
  if (errors && typeof errors === 'object') {
    description = Object.values(errors).flat();
  }

  return new DeleteErrorException(description, message);
}
